/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React from 'react';

import cn from 'classnames';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { updateUserPreference } from 'actions/user';
import { RenderForGlobalExchange } from 'components/render/RenderByExchangeType';
import Popover from 'containers/Popover';
import { getProductSymbol, preLoginFavoriteClick } from 'helpers/utils';
import { useToggle } from 'hooks';
import { userPreferencesSelector } from 'selectors';
import {
  ArrowDownThin,
  Favorite,
  FavoriteSelected,
  SpotIconSymbol,
} from 'styles/assets/icons';

import styles from './index.module.scss';

const DesktopHeaderDropdownBox = ({ selected_product, onClick, isOpen, isLoggedIn }) => {
  const { initial_margin, contract_type, id } = selected_product;
  const leverage = Math.trunc(100 / Number(initial_margin));
  const dispatch = useDispatch();
  const [loading, toggleLoading] = useToggle(false);

  const arrowClassName = isOpen ? styles.rotate : '';
  const userPreferences = useSelector(state => userPreferencesSelector(state));
  const { favorites = [] } = userPreferences;

  const isFavorite = favorites ? favorites.includes(id) : false;

  const saveFavoritesToPreferences = productId => {
    if (isLoggedIn && !loading) {
      toggleLoading();
      dispatch(
        updateUserPreference(
          {
            preferences: {
              favorites: favorites.some(pid => pid === productId)
                ? favorites.filter(pid => pid !== productId)
                : favorites.concat(productId),
            },
          },
          { disable_notification: true }
        )
      ).then(() => toggleLoading());
    }
  };

  return (
    (<div
      className={styles['desktop-dropdown-box']}
      data-palette="DesktopHeaderDropdownBox">
      <div
        data-testid={`saveFavoritesToPreferences-${id}`}
        aria-hidden="true"
        className={styles['favorite-icon']}
        onClick={e => saveFavoritesToPreferences(id)}
      >
        {isFavorite ? (
          <FavoriteSelected className={cn(styles.active, { loading })} />
        ) : isLoggedIn ? (
          <FavoriteSelected className={cn({ loading })} />
        ) : (
          <Popover
            body={
              <Trans i18nKey="trading:addWatchlistToolTip">
                {/* <b className="login-tooltip" /> */}
              </Trans>
            }
            shouldEnableClickListener
          >
            {thisProps => (
              <FavoriteSelected
                data-testid="preLoginFavoriteClick"
                onClick={e => preLoginFavoriteClick(e, thisProps.setOpen)}
              />
            )}
          </Popover>
        )}
      </div>
      <div
        data-testid="header-dropdown-box"
        aria-hidden="true"
        className={styles['dropdown-box']}
        onClick={onClick}
        id="header-dropdown-box"
      >
        <div className={styles['symbol-favorites-desktop']}>
          <h1 className={styles.text}>{getProductSymbol(selected_product)}</h1>
        </div>
        {contract_type === 'spot' && <SpotIconSymbol className={styles['spot-icon']} />}
        <RenderForGlobalExchange>
          {contract_type !== 'spot' && <div className={styles.leverage} data-palette="DesktopHeaderDropdownBox">{leverage}x</div>}
        </RenderForGlobalExchange>
        <ArrowDownThin className={`${arrowClassName} ${styles.arrow}`} />
      </div>
    </div>)
  );
};

export const MobileHeaderDropdownBox = ({
  selected_product,
  openDropdown,
  isOpen,
  isLoggedIn,
}) => {
  const { short_description, id, description, contract_type } = selected_product;
  const dispatch = useDispatch();
  // const leverage = 100 / Number(initial_margin);
  const userPrefrences = useSelector(state => userPreferencesSelector(state));
  const isFavorite = userPrefrences.favorites
    ? userPrefrences.favorites.includes(id)
    : false;

  const saveFavoritesToPreferences = productId => {
    if (isLoggedIn) {
      dispatch(
        updateUserPreference(
          {
            preferences: {
              favorites: userPrefrences.favorites
                ? userPrefrences.favorites.some(pid => pid === productId)
                  ? userPrefrences.favorites.filter(pid => pid !== productId)
                  : userPrefrences.favorites.concat(productId)
                : (userPrefrences.favorites = [productId]),
            },
          },
          { disable_notification: true }
        )
      );
    }
  };

  return (
    (<div
      className={styles['mobile-dropdown-box']}
      id="header-dropdown-box"
      data-palette="MobileHeaderDropdownBox">
      <div
        data-testid={`mobileSaveFavoritesToPreferences-${id}`}
        aria-hidden="true"
        className={styles['favorite-icon']}
        onClick={() => saveFavoritesToPreferences(id)}
      >
        {isFavorite ? (
          <FavoriteSelected />
        ) : isLoggedIn ? (
          <Favorite />
        ) : (
          <Popover
            body={
              <Trans i18nKey="trading:addWatchlistToolTip">
                {/* <b className="login-tooltip" /> */}
              </Trans>
            }
            shouldEnableClickListener
          >
            {thisProps => (
              <Favorite
                data-testid="preLoginFavoriteClick"
                onClick={e => preLoginFavoriteClick(e, thisProps.setOpen)}
              />
            )}
          </Popover>
        )}
      </div>
      <div
        data-testid="headerDropdownBox"
        aria-hidden="true"
        className={styles['contract-name']}
        onClick={() => openDropdown()}
      >
        <h1 className={cn(styles['symbol-area'], styles.text)}>
          {getProductSymbol(selected_product)}
          {contract_type === 'spot' && <SpotIconSymbol className={styles['spot-icon']} />}
          <ArrowDownThin className={styles.arrow} />
        </h1>
        <div className={styles['short-description']}>
          {short_description || description.split(',')[0]}
        </div>
      </div>
      {/* {contract_type === 'spot' && <SpotIcon className={styles['spot-icon']} />} */}
      {/* {contract_type !== 'spot' && (
        <div className={styles.leverage}>{leverage}x</div>
      )} */}
    </div>)
  );
};

export default DesktopHeaderDropdownBox;
